
export function initStickyHeader(options = {}) {
	const { selector = "#header", offset = 50, activeClass = "is-scrolled" } = options;

	const header = document.querySelector(selector);
	if (!header) return; 

	let ticking = false;
	let isScrolled = false; 

	function update() {
		const shouldBeScrolled = window.scrollY > offset;

		if (shouldBeScrolled !== isScrolled) {
			header.classList.toggle(activeClass, shouldBeScrolled);
			isScrolled = shouldBeScrolled;
		}

		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(update);
		}
	}

	window.addEventListener("scroll", onScroll, { passive: true });

	update();

	return () => {
		window.removeEventListener("scroll", onScroll);
	};
}
